module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-mgp-slot.c88f23c2.png";